// Shared visual tokens for the scheduling, retail and product-pick wizards.
// Mapped onto the creator revamp palette (`ff` in theme.ts, boards lime/project/BookVisit, RetailSchedule,
// PickProducts). Key names are kept so every call site restyles without touching its logic.
import { ff } from '../../../theme';

const solid = (c: string) => `linear(to-b, ${c}, ${c})`;

export const wizardTokens = {
  // Surfaces (gradient-shaped so `bgGradient` call sites stay valid; all solid now)
  darkGradient: solid(ff.ink),
  cardGradient: solid('#FFFFFF'),
  chipGradient: solid(ff.grey),
  frostedBar: '#FFFFFF',

  // Colors
  ink: ff.ink,
  inkMuted: '#55555A',
  inkFaint: ff.muted,
  ring: ff.ink,
  hairline: ff.border,
  progressActive: ff.ink,
  progressInactive: ff.card,

  // Selected-option treatment (boards): 2px ink border + lime-surface fill.
  selectedBorder: ff.ink,
  selectedBg: solid(ff.limeSurface),
  selectedTick: ff.ink,
  // A card the creator still owes a decision on — included, but not yet settled.
  attentionBorder: '#B54708',
  attentionBg: solid('#FFF1D6'),
  attentionInk: '#5C3900',

  // Radii
  radiusCard: '16px',
  radiusBar: '14px',
  radiusSelection: '16px',
  radiusCta: '999px',
  radiusChip: '12px',
  radiusRow: '16px',

  // Sizes
  ctaHeight: '56px',
  maxColumnWidth: '480px',

  cardShadow: 'none',
} as const;

/** Board step-page title: 44px on the 390px board, scaled ×0.8. */
export const stepTitleProps = {
  as: 'h1' as const,
  m: 0,
  textStyle: 'display',
  fontSize: '35px',
  lineHeight: 1.12,
  color: ff.ink,
};

/** Small uppercase label used for section heads and summary keys. */
export const eyebrowProps = {
  fontSize: '10px',
  fontWeight: 600,
  letterSpacing: '0.1em',
  textTransform: 'uppercase' as const,
  color: '#66666A',
};

// Selected-card treatment: 2px ink ring (paired with the lime-surface selectedBg fill).
export const selectedRing = `0 0 0 2px ${wizardTokens.selectedBorder}`;

// Same treatment in amber, for a card that is included but still awaiting a choice.
export const attentionRing = `0 0 0 2px ${wizardTokens.attentionBorder}`;
